<template>
  <form name="notification-banners-form" @submit.prevent>
    <BLayoutExpansion title="Базовая информация" class="my-4">
      <v-row dense>
        <v-col cols="12" md="8" lg="6">
          <BTextField
            v-model="form.name"
            validate="required"
            label="Название"
            :disabled="isView"
            :skeleton="skeleton"
            name="name"
            autofocus
          />
        </v-col>
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>

        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.updated_at | dateFormatter"
            :skeleton="skeleton"
            label="Обновлен"
            disabled
          />
        </v-col>
      </v-row>

      <v-row v-if="!isView" dense>
        <v-spacer />
        <v-col cols="auto">
          <BFormButtons
            :loading="loading"
            :save-menu-list="saveMenuList"
            :skeleton="skeleton"
            saveable
            @save-menu="$emit('save', $event)"
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <ParticipantsUsersList
      v-if="!isCreate && data.id"
      :participants_id="data.id"
      :skeleton="skeleton"
      :readonly="!canEdit"
    />

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BFormButtons, { SAVE_MENUS } from '@/components/common/BFormButtons.vue'
import ParticipantsUsersList from '@/views/ParticipantsUsers/ParticipantsUsersList.vue'
import { lkParticipantPermissions as Permissions } from '@/helpers/enums/permission-models'


const createDefaultData = () => ({
  // ..
})


export default {
  name: 'ParticipantsForm',
  components: {
    BLayoutExpansion,
    BTextField,
    BFormButtons,
    ParticipantsUsersList,
  },
  extends: BLayoutForm,
  props: {
    loading: Boolean,
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  data: () => ({
    saveMenuList: Object.values(SAVE_MENUS),
  }),
  computed: {
    canEdit() {
      return this.$access(Permissions.edit)
    },
  },
  methods: {
    async onSubmit() {
      const result = await this.$validator.validate()

      if (!result) {
        this.$notice.validatorFormError(this)
        const message = `Error submit: ${this.$options.name}`
        const error = new Error(message)
        return Promise.reject(error)
      }

      const { form } = this

      const data = {
        ...form,
      }

      this.$emit('submit', data)

      return data
    },
  },
}
</script>
